import React from 'react';
import ShipmentOverflowTooltip from './ShipmentOverflowTooltip';

interface ShipmentTablePlainCellProps {
  value?: string;
}

const ShipmentTablePlainCell: React.FC<ShipmentTablePlainCellProps> = ({
  value = '',
}) => {
  return (
    <span className='shipment-grid-plain-cell-wrap'>
      <ShipmentOverflowTooltip
        text={value}
        className='shipment-grid-plain-cell'
      />
    </span>
  );
};

export default ShipmentTablePlainCell;
